import {isValidDate} from '../timeManagment/validators';

export const testTitle = ( newTitle: string ) : string => {

	let errorMessage: string = "";

	if ( newTitle === "" )
	 {
	  errorMessage = "Il manque le titre"
     }

    return errorMessage
  }

export const testShortTitle = ( newShortTitle: string ) : string => {

	let errorMessage: string = "";

	if ( newShortTitle === "" )
	 {
	  errorMessage = "Il manque le titre court"
	 }

    return errorMessage
  }

export const testComplementToTheTitle = ( newComplementToTheTitle: string ) : string => {

	let errorMessage: string = "";

	if ( newComplementToTheTitle === "" )
	 {
	  errorMessage = "Il manque le complément du titre"
	 }

    return errorMessage
  }

export const testDescription = ( newDescription: string ) : string => {

	let errorMessage: string = "";

	if ( newDescription === "" )
	 {
	  errorMessage = "Il manque la description"
	 }

    return errorMessage
  }

export const testDuration = ( newDuration: string ) : string => {

	let errorMessage: string = "";

	if ( newDuration === "" )
	      {
	       errorMessage = "Il manque la durée"
	      }
	 else {
    	   const regex = /^(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d$/;

	       if ( regex.test ( newDuration ) === false )
	        {
	         errorMessage = "La durée doit être au format HH:MM:SS"
	        }
	      }

    return errorMessage
  }

export const testDistribution = ( newDistribution: string ) : string => {

	let errorMessage: string = "";

	if ( newDistribution === "" )
	 {
	  errorMessage = "Il manque la distribution"
	 }

    return errorMessage
  }

export const testProduction = ( newProduction: string ) : string => {

	let errorMessage: string = "";

	if ( newProduction === "" )
	 {
	  errorMessage = "Il manque la production"
	 }

    return errorMessage
  }

export const testCopyright = ( newCopyright: string ) : string => {

	let errorMessage: string = "";

	if ( newCopyright === "" )
	 {
	  errorMessage = "Il manque le copyright"
	 }

    return errorMessage
  }

export const testReleaseDate = ( newReleaseDate: string ) : string => {

	let errorMessage: string = "";

	if ( newReleaseDate === "" )
     	  {
	       errorMessage = "Il manque la date de tournage"
	      }
    else if ( isValidDate (newReleaseDate) === false )
	      {
	       errorMessage = "La date de tournage est invalide"
          }

    return errorMessage
  }

export const testFirstUseDate = ( newFirstUseDate: string ) : string => {

	let errorMessage: string = "";

	if ( newFirstUseDate === "" )
     	  {
	       errorMessage = "Il manque la date de première diffusion"
	      }
    else if ( isValidDate (newFirstUseDate) === false )
	      {
	       errorMessage = "La date de première diffusion est invalide"
          }

    return errorMessage
  }

export const testRankingStr = ( newRankingStr: string ) : string => {

	let errorMessage: string = "";

	if ( newRankingStr === "" )
	      {
	       errorMessage = "Il manque le ranking"
	      }
	 else {
    	   const regex = /^\d+$/;

	       if ( regex.test ( newRankingStr ) === false )
	        {
	         errorMessage = "Le ranking doit être un entier"
	        }
	      }

    return errorMessage
  }

export const testNumberOfViewsStr = ( newNumberOfViewsStr: string ) : string => {

	let errorMessage: string = "";

	if ( newNumberOfViewsStr === "" )
	      {
	       errorMessage = "Il manque le nombre de vues"
	      }
	 else {
    	   const regex = /^\d+$/;

	       if ( regex.test ( newNumberOfViewsStr ) === false )
	        {
	         errorMessage = "Le nombre de vues doit être un entier"
	        }
	      }

    return errorMessage
  }


export const testImageFileToUpload = (file: File | undefined): string => {

  let errorMessage: string = "";

  if (!file)
   {
    errorMessage = "Il manque le fichier image"
   }

    return errorMessage
};

export const testImageUrl = ( newImageUrl: string ) : string => {

	let errorMessage: string = "";

	if ( newImageUrl === "" )
	 {
	  errorMessage = "Il manque le fichier image"
	 }

    return errorMessage
  }

export const testSoundFileToUpload = (file: File | undefined): string => {

  let errorMessage: string = "";

  if (!file)
   {
    errorMessage = "Il manque le fichier son"
   }

    return errorMessage
};

export const testSoundUrl = ( newSoundUrl: string ) : string => {

	let errorMessage: string = "";

	if ( newSoundUrl === "" )
	 {
	  errorMessage = "Il manque le fichier son"
	 }

    return errorMessage
  }

export const testVideoUrl = ( newVideoUrl: string ) : string => {

	let errorMessage: string = "";

	if ( newVideoUrl === "" )
	 {
	  errorMessage = "Il manque le fichier video"
	 }

    return errorMessage
  }


export const testVideoFileToUpload = (file: File | undefined): string => {

  let errorMessage: string = "";

  if (!file)
   {
    errorMessage = "Il manque le fichier video"
   }

  return errorMessage
};

export const testRequiredUserStatusId = ( newRequiredUserStatusId : number): string => {

  console.log ('testRequiredUserStatusId', newRequiredUserStatusId)

  let errorMessage: string = "";

  if (newRequiredUserStatusId===0)
   {
    errorMessage = "Il manque le statut utilisateur requis"
   }

  return errorMessage
};

export const testCategoriesIds = ( newCategoriesIds : number[]): string => {

  console.log ('testCategoriesIds', newCategoriesIds)

  let errorMessage: string = "";

  if (newCategoriesIds.length===0)
   {
    errorMessage = "Il faut choisir au moins une catégorie"
   }

  return errorMessage
};

